import { storeService } from '../../apis/store.s';
import { FETCH_STORES_DONE, FETCH_CURRENT_STORE_DONE } from '../mutations.type';

import { FETCH_STORES, FETCH_CURRENT_STORE } from '../actions.type';
const initialState = {
  stores: [],
  currentStore: null,
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_STORES](context) {
    const { data } = await storeService.list();

    context.commit(FETCH_STORES_DONE, data);
    return data;
  },

  async [FETCH_CURRENT_STORE](context) {
    const { data } = await storeService.getCurrentStore();

    context.commit(FETCH_CURRENT_STORE_DONE, data);
    return data;
  },
};

/* eslint no-param-reassign: ['error', { 'props': false }] */
export const mutations = {
  [FETCH_STORES_DONE](state, data) {
    state.stores = data?.filter(store => {
      if (typeof store == 'object') {
        return store;
      }
    });
  },

  [FETCH_CURRENT_STORE_DONE](state, data) {
    state.currentStore = data;
  },
};

const getters = {
  stores(state) {
    return state.stores;
  },

  currentStore(state) {
    return state.currentStore;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
